import style from '@magoosh/pages/payment_flows/subscription_form/style.module.scss';
import { FieldInput } from 'react/lib/formik_inputs/field_input/template';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import cx from 'classnames';
import React from 'react';

interface Props {
  errors: any;
}

const FIELD_OPTIONS = {
  style: {
    base: {
      color: '#4e4b50',
      fontFamily: '"Tondo", Arial, "Helvetica Neue", Helvetica, sans-serif',
      fontSize: '16px',
      lineHeight: '1.5',
      fontSmoothing: 'antialiased'
    }
  }
};

const StripeCardInputs: React.FC<Props> = (props) => {
  const { errors } = props;
  return (
    <>
      <div className={style.errorMessage}>
        {errors?.stripePaymentMethod && <span>{errors.stripePaymentMethod}</span>}
      </div>
      <FieldInput
        name="cardName"
        type="input"
        label="Full Name"
        hint="As it appears on the front of your card"
        className={style.largeStringInput}
      />
      <Row>
        <Col md={6}>
          <ControlLabel>Card Number:</ControlLabel>
          <CardNumberElement options={FIELD_OPTIONS} className="form-control" />
          <p>
            <small>As it appears on the front of your card</small>
          </p>
        </Col>
        <Col md={6}>
          <ControlLabel>Security Code:</ControlLabel>
          <CardCvcElement options={FIELD_OPTIONS} className={cx(style.miniStringInput, 'form-control')} />
          <p>
            <small>3 digit code on the back of your card (4 digits on the front for American Express)</small>
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <div className={'u-margin-T-s'}>
            <ControlLabel>Expiration Date:</ControlLabel>
            <CardExpiryElement
              options={FIELD_OPTIONS}
              className={cx(style.smallStringInput, 'form-control')}
            />
            <div className={style.errorMessage}>
              {errors?.cardExpirationDate &&
                errors.cardExpirationDate.map((errorMessage) => (
                  <span key={errorMessage}>{errorMessage}</span>
                ))}
            </div>
          </div>
        </Col>

        <Col md={6}>
          <FieldInput
            name="cardZipCode"
            type="input"
            label="Billing ZIP"
            hint="Or Postal Code if you're not in the USA"
            className={style.smallStringInput}
          />
        </Col>
      </Row>
    </>
  );
};

export default StripeCardInputs;
